import styled from 'styled-components';

import Button from 'components/Buttons';

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
`;

export const CompanyDetails = styled.span`
  margin-bottom: 10px;
`;

export const BackButton = styled(Button)`
  align-self: baseline;
`;
